'use strict';

var FaresAverageInversionTransformerFactory = function FaresAverageInversionTransformerFactory(DataTransformer, momentService) {
  function FaresAverageInversionTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['fares-inversion-mode'];
    this.targetType = ['fares-inversion'];
    this.priority = 1;
  }
  FaresAverageInversionTransformer.prototype = Object.create(DataTransformer.prototype);
  FaresAverageInversionTransformer.constructor = FaresAverageInversionTransformer;
  FaresAverageInversionTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  FaresAverageInversionTransformer.prototype.isCacheable = function () {
    return false;
  };
  FaresAverageInversionTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  FaresAverageInversionTransformer.prototype.transform = function (data) {
    if (data.domain.results) {
      var results = data.domain.results;
      for (var index = 0, dataLength = results.length; index < dataLength; index++) {
        var element = results[index];
        element.market = element.marketOrigin + '-' + element.marketDestination;
        element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
      }
      return results;
    } else {
      return [];
    }
  };
  return FaresAverageInversionTransformer;
};
FaresAverageInversionTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = FaresAverageInversionTransformerFactory;